import { render, staticRenderFns } from "./WechatSignin.vue?vue&type=template&id=17a641e1&"
import script from "./WechatSignin.vue?vue&type=script&lang=js&"
export * from "./WechatSignin.vue?vue&type=script&lang=js&"
import style0 from "./WechatSignin.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports